import React, { useEffect, useState } from "react";

import { Container, Grid, TextField, Button, Select, MenuItem } from "@material-ui/core";
import Label from "../../../components/Label";
import { Content } from "./styles";

import Event from "../../../services/event";
import { config } from "../../../config";

import DateFnsUtils from "@date-io/date-fns";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { format } from "date-fns";
import { zonedTimeToUtc } from "date-fns-tz";
import { toast } from "react-toastify";

const AddActivity = (props) => {
    const [values, setValues] = useState({
        name: "",
        description: "",
        obs: "",
        attachment: "",
        start_at: new Date(),
        finish_at: new Date(),
        start_hour: "",
        finish_hour: "",
        enable: true,
        event_id: 1,
    });
    const [error, setError] = useState(null);

    function onChange(event) {
        const { value, name } = event.target;
        setValues({ ...values, [name]: value });
    }

    const handleDateStartAt = (date) => {
        setValues({ ...values, start_at: date });
    };
    const handleDateFinishAt = (date) => {
        setValues({ ...values, finish_at: date });
    };

    const isValidFormFields = () => {
        let isValid = true;
        const errors = [];
        Object.entries(values).forEach(([key, value]) => {
            if (key === "name") {
                if (value === "" || !value) {
                    isValid = false;
                    errors.push("Insira um nome válido");
                }
            }
        });
        if (errors && errors.length) errors.map((e) => toast.warn(e));
        return isValid;
    };

    const formatData = () => {
        return {
            ...values,
            start_at: format(
                zonedTimeToUtc(format(values.start_at, `yyyy-MM-dd ${values.start_hour}:00}`), "America/Sao_Paulo"),
                `yyyy-MM-dd ${values.start_hour}:00`
            ),
            finish_at: format(
                zonedTimeToUtc(format(values.finish_at, `yyyy-MM-dd ${values.finish_hour}:00}`), "America/Sao_Paulo"),
                `yyyy-MM-dd ${values.finish_hour}:00`
            ),
        };
    };

    function onSubmit(event) {
        event.preventDefault();
        if (!isValidFormFields()) return;
        const formatedData = formatData();
        Event.createActivity(formatedData)
            .then((resp) => {
                if (!!resp.data) {
                    toast.success("Atividade criada com sucesso!");
                    window.location.reload();
                } else {
                    console.log(resp);
                    toast.error("Desculpe, ocorreu um erro");
                }
            })
            .catch(function (error) {
                toast.error(error);
            });
    }

    const [hours, setHours] = useState([]);

    useEffect(() => {
        var times = [];
        var tt = 0;
        for (var i = 0; tt < 24 * 60; i++) {
            var hh = Math.floor(tt / 60);
            var mm = tt % 60;
            times[i] = ("0" + (hh % 24)).slice(-2) + ":" + ("0" + mm).slice(-2);
            tt = tt + 30;
        }
        setHours(times);
    }, []);

    return (
        <Container component="main" maxWidth="sm">
            <Content>
                <Label size="medium" color="dark" align="center">
                    Nova Atividade
                </Label>
                <form onSubmit={onSubmit}>
                    <Grid container justify="space-around" spacing={2}>
                        <Grid item md={12}>
                            <TextField
                                key="nome"
                                name="name"
                                required
                                label="Nome"
                                onChange={onChange}
                                value={values.name}
                                fullWidth
                            />
                        </Grid>
                        <Grid item md={12}>
                            <TextField
                                key="description"
                                name="description"
                                label="Descrição"
                                onChange={onChange}
                                value={values.description}
                                fullWidth
                            />
                        </Grid>
                        <Grid item md={12}>
                            <TextField
                                key="obs"
                                name="obs"
                                label="Observação"
                                onChange={onChange}
                                value={values.obs}
                                fullWidth
                            />
                        </Grid>
                        {/* <Grid item md={6}>
                            <TextField
                                key="attachment"
                                name="attachment"
                                label="Link"
                                onChange={onChange}
                                value={values.attachment}
                                fullWidth
                                required
                            />
                        </Grid> */}
                        {/* <Grid item md={6}>
                            <TextField
                                key="event_id"
                                name="event_id"
                                label="Evento"
                                onChange={onChange}
                                value={values.event_id}
                                fullWidth
                                required
                            />
                        </Grid> */}
                    </Grid>
                    <Grid container justify="space-around" spacing={2}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <Grid item md={3} xs={6}>
                                <KeyboardDatePicker
                                    disableToolbar
                                    variant="inline"
                                    format="yyyy-MM-dd"
                                    margin="normal"
                                    name="start_at"
                                    label="Inicio"
                                    value={values.start_at}
                                    onChange={handleDateStartAt}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                />
                            </Grid>
                        </MuiPickersUtilsProvider>
                        <Grid item>
                            <Select name="start_hour" value={values.start_hour} onChange={onChange}>
                                {hours.map((item) => (
                                    <MenuItem value={item}>{item}</MenuItem>
                                ))}
                            </Select>
                        </Grid>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <Grid item md={3} xs={6}>
                                <KeyboardDatePicker
                                    disableToolbar
                                    variant="inline"
                                    format="yyyy-MM-dd"
                                    margin="normal"
                                    name="finish_at"
                                    label="Término"
                                    value={values.finish_at}
                                    onChange={handleDateFinishAt}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                />
                            </Grid>
                        </MuiPickersUtilsProvider>
                        <Grid item>
                            <Select label="Horario" name="finish_hour" value={values.finish_hour} onChange={onChange}>
                                {hours.map((item) => (
                                    <MenuItem value={item}>{item}</MenuItem>
                                ))}
                            </Select>
                        </Grid>
                    </Grid>
                    <div className="content_button">{error && <div className="user-login__error">{error}</div>}</div>
                    <div className="content_button">
                        <Grid container spacing={1}>
                            <Grid item>
                                <Button
                                    className="button"
                                    variant="contained"
                                    color="primary"
                                    disableElevation
                                    onClick={() => props.close()}
                                >
                                    Cancelar
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    className="button"
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    disableElevation
                                >
                                    Criar
                                </Button>
                            </Grid>
                        </Grid>
                    </div>
                </form>
            </Content>
        </Container>
    );
};

export default AddActivity;
